const global = {
  state: {
    status: {
      full: false //首页是否全屏
    },
    login: false
  },
  mutations: {
    SET_STATUS: (state, status) => {
      state.status = Object.assign(state.status, status)
    },
    SET_LOGIN: (state, login) => {
      state.login = login
    },
    SWITCH_FULL: state => {
      state.status.full = !state.status.full
    }
  },
  actions: {
    UpdataStatus({ commit }, status) {
      commit('SET_STATUS', status)
    },
    SwitchFull({ commit }) {
      commit('SWITCH_FULL')
    },
    Login({ commit, dispatch }, login) {
      commit('SET_LOGIN', login)
    }
  }
}

export default global



// WEBPACK FOOTER //
// ./src/framework/store/global.js